import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "nk_token";

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

// Resolve a stored value that may be an API relative path or absolute URL
export const resolveUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

export const api = {
  getSettings: () => http.get("/settings").then((r) => r.data),
  updateSettings: (data) => http.put("/settings", data).then((r) => r.data),
  list: (type) => http.get(`/content/${type}`).then((r) => r.data),
  create: (type, data) => http.post(`/content/${type}`, data).then((r) => r.data),
  update: (type, id, data) => http.put(`/content/${type}/${id}`, data).then((r) => r.data),
  remove: (type, id) => http.delete(`/content/${type}/${id}`).then((r) => r.data),
  reorder: (type, ids) => http.post(`/content/${type}/reorder`, { ids }).then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  createMessage: (data) => http.post("/messages", data).then((r) => r.data),
  depotSpots: () => http.get("/depot/spots").then((r) => r.data),
  depotLookup: (q) => http.get("/depot-bookings/lookup", { params: { q } }).then((r) => r.data),
  createDepotBooking: (data) => http.post("/depot/bookings", data).then((r) => r.data),
  depotBookings: () => http.get("/depot/bookings").then((r) => r.data),
  exportDepotBookings: (fmt) => http.get(`/depot/bookings/export/${fmt}`, { responseType: "blob" }).then((r) => r.data),
  depotSpotsAll: () => http.get("/depot/spots/all").then((r) => r.data),
  createManualBooking: (data) => http.post("/depot/bookings/manual", data).then((r) => r.data),
  updateDepotBooking: (id, data) => http.put(`/depot/bookings/${id}`, data).then((r) => r.data),
  resendDepotConfirmation: (id) => http.post(`/depot/bookings/${id}/resend`).then((r) => r.data),
  deleteDepotBooking: (id) => http.delete(`/depot/bookings/${id}`).then((r) => r.data),
  listMessages: () => http.get("/messages").then((r) => r.data),
  removeMessage: (id) => http.delete(`/messages/${id}`).then((r) => r.data),
  markRead: (id) => http.post(`/messages/${id}/read`).then((r) => r.data),
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  subscribeNewsletter: (email, source) => http.post("/newsletter/subscribe", { email, source }).then((r) => r.data),
  newsletterSubscribers: () => http.get("/newsletter/subscribers").then((r) => r.data),
  deleteSubscriber: (id) => http.delete(`/newsletter/subscribers/${id}`).then((r) => r.data),
  boardPosts: () => http.get("/board/posts").then((r) => r.data),
  createBoardPost: (data) => http.post("/board/posts", data).then((r) => r.data),
  updateBoardPost: (id, data) => http.put(`/board/posts/${id}`, data).then((r) => r.data),
  deleteBoardPost: (id) => http.delete(`/board/posts/${id}`).then((r) => r.data),
  logout: () => http.post("/auth/logout").then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Något gick fel. Försök igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
